export const INITIAL_FORM_DATA = {
  name: '',
  dateOfIncident: '',
  position: '',
  department: '',
  supervisor: '',
  dateOfHire: '2024-01-01',
  policyViolationIds: [] as string[],
  descriptionOfOneOnOne: '',
  coreValues: [] as string[],
  meetingGoal: '',
  privateNotes: '',
};

export const CORE_VALUES = [
  { id: 'innovation', label: 'Innovation' },
  { id: 'growth', label: 'Growth' },
  { id: 'connection', label: 'Connection' },
  { id: 'collaboration', label: 'Collaboration' },
];
